import React, { useEffect, useState } from 'react'
import { useNetworkStatus } from '../../utils/networkStatus'
import { StatusOfflineIcon, CheckCircleIcon } from '@heroicons/react/outline'
import clsx from 'clsx'

export default function LoginNetworkStatusAlert() {
    const [showStatus, setShowStatus] = useState(false)
    const [statusMessage, setStatusMessage] = useState('')

    const { isOffline } = useNetworkStatus()

    useEffect(() => {
        if (!isOffline && showStatus) {
            const bannerTimeout = setTimeout(() => {
                console.log('After 3 seconds we remove the banner')
                setShowStatus(false)
                setStatusMessage('')
            }, 3000)

            return () => clearTimeout(bannerTimeout)
        }
    }, [statusMessage])

    useEffect(() => {
        if (isOffline) {
            setShowStatus(true)
            setStatusMessage('No internet connection')
        } else {
            if (showStatus) {
                setStatusMessage('Back Online')
            }
        }
    }, [isOffline])

    return (
        <div
            className={clsx(
                'w-full flex justify-center items-center gap-2 px-3 transition-all duration-300 ease-in-out',
                isOffline ? 'bg-bannerOffline' : 'bg-bannerOnline',
                showStatus ? 'max-h-6.5 py-1.5' : 'max-h-0 py-0',
            )}
            role="alert"
        >
            {showStatus && (
                <>
                    {isOffline ? (
                        <StatusOfflineIcon className="h-3 w-3 text-white" />
                    ) : (
                        <CheckCircleIcon className="h-3 w-3 text-white" />
                    )}
                    <p className={clsx('font-medium text-xs text-white')}>
                        {statusMessage}
                    </p>
                </>
            )}
        </div>
    )
}
